// src/IzakayaList.js
import React from 'react';

// 居酒屋データの配列
const izakayas = [
  { id: 1, name: "発酵バー醸（かもす）", description: "長野駅にある日本酒飲み比べのできるバーです" },
  { id: 2, name: "酒場食堂ニューゴールデン", description: "大瓶が399円と安い店。上田の追いタレ焼き鳥や、山賊焼など長野の名物があります。" },
  { id: 3, name: "がばい寅次郎", description: "信州の日本酒の飲み放題、名物もあるお店" },
];

const IzakayaList = ({ onIzakayaClick }) => {
  return (
    <div className="izakaya-list">
      <h2>居酒屋リスト</h2>
      <ul>
        {izakayas.map((izakaya) => (
          <li
            key={izakaya.id}
            onClick={() => onIzakayaClick(izakaya.id)} // クリック時に親にIDを渡す
            style={{ cursor: 'pointer' }} // カーソルをポインタに変更
          >
            <h3>{izakaya.name}</h3>
            <p>{izakaya.description}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default IzakayaList;
